import React from 'react'

export const Spy = (props: any) => {
  return (
    <svg
      width={24}
      viewBox="0 0 413 413"
      xmlns="http://www.w3.org/2000/svg"
      {...props.style}>
      <path
        id="small-circle4"
        fill="#2151a1"
        d="M 355.48,207.03
            C 355.48,289.51 288.62,356.37 206.13,356.37
              123.65,356.37 56.78,289.51 56.78,207.03
              56.78,124.55 123.65,57.68 206.13,57.68
              288.62,57.68 355.48,124.55 355.48,207.03 Z"
      />
      <text
        id="#text"
        x="50%"
        y="55%"
        fill="white"
        dominant-baseline="middle"
        text-anchor="middle"
        fontSize={'250'}>
        {props.number}
      </text>
      <path
        id="crosshair4"
        fill="currentColor"
        d="M 194.14,82.83
            C 194.14,82.83 217.55,82.83 217.55,82.83
              217.55,82.83 217.54,56.93 217.54,56.93
              291.08,62.49 349.81,121.05 355.63,194.51
              355.63,194.51 329.84,194.50 329.84,194.50
              329.84,194.50 329.84,217.17 329.84,217.17
              329.84,217.17 355.73,217.17 355.73,217.17
              350.55,291.08 291.84,350.22 218.12,356.08
              218.12,356.08 218.12,330.33 218.12,330.33
              218.12,330.33 194.68,330.33 194.68,330.33
              194.68,330.33 194.68,356.13 194.68,356.13
              120.91,350.59 62.01,291.71 56.46,217.95
              56.46,217.95 82.85,217.95 82.85,217.95
              82.85,217.95 82.85,195.53 82.85,195.53
              82.85,195.53 56.43,195.53 56.43,195.53
              61.78,121.75 120.48,62.76 194.14,56.96
              194.14,56.96 194.14,82.83 194.14,82.83 Z
            M 217.55,0.04
            C 217.55,0.04 194.14,0.04 194.14,0.04
              194.14,0.04 194.14,26.87 194.14,26.87
              103.90,32.77 31.79,105.16 26.35,195.53
              26.35,195.53 0.02,195.53 0.02,195.53
              0.02,195.53 0.02,217.95 0.02,217.95
              0.02,217.95 26.38,217.95 26.38,217.95
              32.04,308.29 104.33,380.57 194.68,386.20
              194.68,386.20 194.68,413.17 194.68,413.17
              194.68,413.17 218.12,413.17 218.12,413.17
              218.12,413.17 218.11,386.16 218.11,386.16
              308.42,380.20 380.52,307.65 385.80,217.16
              385.80,217.16 412.90,217.17 412.90,217.17
              412.90,217.17 412.90,194.50 412.90,194.50
              412.90,194.50 385.71,194.53 385.71,194.53
              379.79,104.49 307.67,32.52 217.55,26.85
              217.55,26.85 217.55,0.04 217.55,0.04 Z"
      />
    </svg>
  )
}